// extracted by mini-css-extract-plugin
module.exports = {"checkbox__item":"SearchCheckbox_checkbox__item__1Mwqi"};